var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2108 0.960782L6.58578 6.58578C6.53354 6.63808 6.4715 6.67957 6.40322 6.70788C6.33493 6.73618 6.26173 6.75075 6.18781 6.75075C6.11389 6.75075 6.0407 6.73618 5.97241 6.70788C5.90412 6.67957 5.84208 6.63808 5.78984 6.58578L0.164844 0.960782C0.0592961 0.855234 0 0.71208 0 0.562813C0 0.413545 0.0592961 0.270392 0.164844 0.164844C0.270392 0.0592959 0.413546 0 0.562813 0C0.71208 0 0.855234 0.0592959 0.960781 0.164844L6.18781 5.39258L11.4148 0.164844C11.4671 0.112582 11.5292 0.0711253 11.5974 0.0428413C11.6657 0.0145573 11.7389 0 11.8128 0C11.8867 0 11.9599 0.0145573 12.0282 0.0428413C12.0965 0.0711253 12.1585 0.112582 12.2108 0.164844C12.263 0.217106 12.3045 0.27915 12.3328 0.347433C12.3611 0.415717 12.3756 0.488903 12.3756 0.562813C12.3756 0.636722 12.3611 0.709908 12.3328 0.778192C12.3045 0.846475 12.263 0.90852 12.2108 0.960782Z",
    fill: "#151516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.7f224ef0077c730f8f4a37d9764ff80e.svg";
export { ForwardRef as ReactComponent };